<template>
	<div class="list-container column">
		<div class="title">{{ $t('grouplist.title') }}</div>
		<div class="panel-list-header">
			<div class="panel-header-item">{{ $t('grouplist.column_name') }}</div>
			<div v-if="!isMobile" class="panel-header-item">{{ $t('grouplist.column_question_count') }}</div>
			<div class="panel-filler" />
		</div>
		<div
			class="panel-list"
			v-for="questionGroup in questionGroups"
			:key="questionGroup.id"
			:class="questionGroup.id == activeQuestionGroup.id ? 'active' : ''"
			@click="onSelect(questionGroup)"
		>
			<div class="panel-list-item">{{ questionGroup.name }}</div>
			<div v-if="!isMobile" class="panel-list-item">
				{{ questionGroup.questions.length }}
				{{ questionGroup.questions.length != 1 ? $t('grouplist.questions_plural') : $t('grouplist.questions_singular') }}
			</div>
			<div class="list-button" @click.stop="onEdit(questionGroup)">
				<i class="fas fa-edit"></i>
			</div>
			<!-- Disabled delete until its verified in api
        <div class="list-button" @click.stop="onDelete(questionGroup)">
          <i class="fas fa-trash-alt"></i>
        </div>
        -->
		</div>
		<div class="panel-list no-hover" v-if="questionGroups.length == 0">
			<p class="header-item">{{ $t('grouplist.no_results') }}t</p>
		</div>
		<Pagination
			v-if="questionGroups.length > 0"
			:pagination="pagination"
			@paginate="paginate"
			@updatePageSize="updatePageSize"
		/>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { mapGetters, mapActions } from 'vuex';

export default {
	components: {
		Pagination
	},
	props: {
		questionGroups: Array,
		activeQuestionGroup: Object
	},
	computed: {
		...mapGetters('questionGroupStore', ['pagination']),
		...mapGetters('appStore', ['isMobile'])
	},
	methods: {
		...mapActions('questionGroupStore', ['setCurrentPage', 'setPageSize']),
		onDelete(questionGroup) {
			this.$emit('delete', questionGroup);
		},
		onEdit(questionGroup) {
			this.$emit('edit', questionGroup);
		},
		onSelect(questionGroup) {
			if (!this.isMobile) {
				this.$emit('select', questionGroup);
			} else {
				this.$emit('navigate', questionGroup.id);
			}
		},
		paginate(page) {
			this.setCurrentPage(page);
			this.$emit('search');
		},
		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.$emit('search');
		}
	}
};
</script>
